import React, { useState } from "react"
import { ReferenceManyField, RaRecord, useGetList } from "react-admin"
import Box from "@mui/material/Box"

import UserService from "UserService"
import { CreatePricingRuleModal } from "./companyModals/CreatePricing"
import { EditPricingRuleModal } from "./companyModals/EditPricing"
import ActionButton from "components/ActionButton"

import "styles.scss"
import { handleEsc } from "common/closeOnEscape"
import { CreateTabletModal } from "./companyModals/CreateTabletModal"
import { CompanyBillingInformation, getCompanyFinancialData, PricingType, Tablet } from "api/company"
import { PricingRulesDatagrid } from "pricingRule/PricingRulesDatagrid"

interface Props {
  type: PricingType
  path: string
  record: RaRecord
}

const PricingRules = ({ path, record, type }: Props) => {
  type OpenModal =
    | {
        type: "EDIT" | "CREATE" | "CREATE_TABLET"
        record: RaRecord
      }
    | undefined
  const [open, setOpen] = React.useState<OpenModal>(undefined)
  const [billingInfo, setBillingInfo] = useState<CompanyBillingInformation | undefined>(undefined)

  const close = () => {
    setOpen(undefined)
  }

  React.useEffect(handleEsc(close), [])

  React.useEffect(() => {
    getCompanyFinancialData(record.id as string).then((response) => {
      setBillingInfo(response)
    })
  }, [])

  const { data: tablets, isLoading } = useGetList<Tablet>("tablets", { filter: { companyId: record.id } })

  if (isLoading) return <></>

  const getTablet = (type: PricingType) =>
    type === "DYNAMIC" ? undefined : tablets?.find((t) => t.pricingRuleId === open?.record?.id)

  const createBoundle = open?.type === "CREATE" && billingInfo && (
    <CreatePricingRuleModal
      record={open.record}
      open={open.type === "CREATE"}
      onClose={close}
      type={type}
      currency={type != "DYNAMIC" ? billingInfo.financialInfo?.currency : 'EUR'}
    />
  )
  const editBoundle = open?.type === "EDIT" && (
    <EditPricingRuleModal record={open.record} open={open.type === "EDIT"} onClose={close} getTablet={getTablet} />
  )
  const createTablet = type != "DYNAMIC" && open?.type === "CREATE_TABLET" && (
    <CreateTabletModal
      record={open.record}
      open={open.type === "CREATE_TABLET"}
      onClose={close}
      getTablet={getTablet}
    />
  )

  const isPmOrAdmin = UserService.hasRoles(["ROLE_PLATFORM_MANAGER"])

  return (
    <>
      {editBoundle}
      {createBoundle}
      {createTablet}

      <Box>
        <Box className="edit-tab">
          <Box className="on-right">
            {isPmOrAdmin && (
              <ActionButton
                onClick={() => {
                  setOpen({ type: "CREATE", record: record })
                }}
              >
                Create
              </ActionButton>
            )}
          </Box>
        </Box>
        <ReferenceManyField
          reference={path}
          target="companyId"
          sort={{ field: "id", order: "DESC" }}
          perPage={50}
          fullWidth
        >
          <PricingRulesDatagrid
            type={type}
            resource={path}
            onEdit={(record) => setOpen({ type: "EDIT", record })}
            onEditTablet={(record) => setOpen({ type: "CREATE_TABLET", record })}
            showTabletButton={true}
          />
        </ReferenceManyField>
      </Box>
    </>
  )
}

export default PricingRules
